import { BaseElement } from "./baseElement.ts";
import { Box } from "../layout/box.ts";
import type { jsPDF } from "jspdf";

export class ImagePdf extends BaseElement {
	kind = "image" as const;
	url: string;

	constructor(box: Box, id: string, url: string) {
		super(box, id);
		this.url = url;
	}

	getImageSizeFromDataUrl(dataUrl: string): Promise<{ width: number; height: number }> {
		return new Promise((resolve, reject) => {
			const img = new Image();

			img.onload = () => {
				resolve({ width: img.naturalWidth, height: img.naturalHeight });
			};

			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			img.onerror = (_) => {
				console.error(this.id, this.url);
				reject(new Error("Failed to load image from data URL"));
			};

			img.src = dataUrl;
		});
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	override async calculate(_: jsPDF) {
		try {
			const { width, height } = await this.getImageSizeFromDataUrl(this.url);
			const ratio = width / height;
			if (this.box.size.height == 0) {
				this.box.size.height = this.box.size.width / ratio;
			}
		} catch {
			/* empty */
		}
	}

	async draw(pdfDocument: jsPDF): Promise<void> {
		try {
			const imageDataUrl = await this._toDataURL(this.url);
			const box = this.box.getBoundingBox();
			pdfDocument.addImage(imageDataUrl, "JPEG", box.x, box.y, box.width, box.height);
		} catch {
			/* empty */
		}
	}

	private async _toDataURL(url: string): Promise<string> {
		const res = await fetch(url, { cache: "no-store", mode: "cors" });
		const blob = await res.blob();
		return new Promise<string>((resolve, reject) => {
			const reader = new FileReader();
			reader.onloadend = () => {
				resolve(reader.result as string);
			};
			reader.onerror = () => reject;
			reader.readAsDataURL(blob);
		});
	}
}
